var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-min"},[_vm._l((_vm.answers.chartsData),function(result,index){return _c('horizontal-bar',{key:index,attrs:{"result":result}})}),_vm._v(" "),_c('p',{staticClass:"mt-min",domProps:{"innerHTML":_vm._s(_vm.$t('tests.messages.inbody_vfa_result', { answer: _vm.answers.vfa }))}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-514683d2","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/tests/InBody/ShowInBodyTest.vue
// module id = O9vO
// module chunks = 0 1